export default function SectionHeading({ eyebrow, title, subtitle, align = "center", light = false, className = "" }) {
    const alignClass = align === "center" ? "mx-auto text-center" : "text-left";
    return (
        <div className={`max-w-2xl ${alignClass} ${className}`}>
            {eyebrow && (
                <span className={`inline-block text-xs font-semibold tracking-widest uppercase px-3 py-1 rounded-full mb-4 ${
                    light ? "text-white bg-white/15" : "text-primary bg-primary-light"
                }`}>
                    {eyebrow}
                </span>
            )}
            <h2
                className={`font-bold tracking-tight ${light ? "text-white" : "text-ink"}`}
                style={{ fontSize: "clamp(1.75rem, 1.35rem + 2vw, 2.75rem)", lineHeight: 1.15 }}
            >
                {title}
            </h2>
            {subtitle && (
                <p className={`mt-3 text-base md:text-lg ${light ? "text-white/80" : "text-ink-muted"}`}>
                    {subtitle}
                </p>
            )}
        </div>
    );
}
